export const ROLES = {
  PROPERTY_ADMIN: "property admin",
  SALESPERSON: "salesperson",
  COACH_ADMIN: "coach admin",
  HYBRID_USER: "hybrid user",
  ACCOUNT_ADMIN: "account admin",
} as const;

export type ROLES = (typeof ROLES)[keyof typeof ROLES];
